exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Login__support___2Oyxa {\n  font-size: 14px;\n  font-style: italic;\n  text-align: center;\n  margin-bottom: 16px;\n  padding: 0 12px;\n}\n", ""]);

// exports
exports.locals = {
	"support": "Login__support___2Oyxa"
};